import { SET_USER, } from "../constants";

export function user(state = false, action) {
  switch (action.type) {
    case SET_USER:
      return action.user
    default:
      return state;
  }
}
